module.exports = __webpack_public_path__ + "img/kodluyoruz-logo.f78c4b18.png";